export const isTest = window.PACETEQ?.IS_TEST ?? false;
